import React from "react";
import AreaTable from "components/Tables/Area/AreaTable";

const ListArea = () => {
  return (
    <div>
      <AreaTable />
    </div>
  );
};

export default ListArea;
